/**
 * Created by 94117 on 2019/4/10.
 */
import NetWork from '../../base/NetWork';
import {Device} from '../../base/Device';

/**
 * @author yeyuchao
 * @description join us.
 */
const screenHeight = window.screen.height;
const screenWidth = window.screen.width;
export default {
  data() {
    return {
      screenHeight:screenHeight,
      screenWidth:screenWidth,
      customerList:["老带新新带新","地推","品牌推广","中介渠道","渠道拓展","异地营销","竞品拦截","合作方配合"],
      device:null,
      deviceMobile:false,
      phoneStyle1:"",
      phoneStyle2:"",
    };
  },
  mounted() {
  },
  created() {
    this.device = new Device();
    if(this.device.phone){
      this.deviceMobile = true;
      this.phoneStyle1 = "margin-left: calc(45vw - 54px);";
      this.phoneStyle2 = "text-align: right;"
    }

  },
  methods:{
    closeDamai(){
      this.$router.push('/elabDo');

    },
  }
};



// WEBPACK FOOTER //
// ./src/pages/elabDamai/elabDamai.js